
/* =============================================
   LORIANNE — UNIFIED WISHLIST SYSTEM
   File: lrn-wishlist-fix.js

   Features:
   - Product add/remove
   - Product ID + Handle matching
   - Improved product extraction
   - Header wishlist count
   - Wishlist drawer
   - Remove from drawer
   - Shopify dynamic section support

   Storage: shop_wishlist_v1
   ============================================= */

(function () {
  'use strict';

  if (window.__LRN_UNIFIED_WISHLIST__) return;
  window.__LRN_UNIFIED_WISHLIST__ = true;

  var STORAGE_KEY = 'shop_wishlist_v1';
  var DRAWER_ID = 'wishlistDrawer';
  var ITEMS_ID = 'wishlistItems';

  /* GET WISHLIST */

  function getWishlist() {
    try {
      var items = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(items) ? items : [];
    } catch (error) {
      console.error('Wishlist storage error:', error);
      return [];
    }
  }

  /* SAVE WISHLIST */

  function saveWishlist(items) {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(items)
    );

    updateCount();
    updateHearts();
    renderDrawer();
  }

  /* PRODUCT MATCHING */

  function isSameProduct(a, b) {
    if (a.id && b.id && String(a.id) === String(b.id)) {
      return true;
    }

    if (
      a.handle &&
      b.handle &&
      a.handle === b.handle
    ) {
      return true;
    }

    if (a.url && b.url && a.url === b.url) {
      return true;
    }

    return false;
  }

  function getKey(product) {
    return product.id ||
      product.handle ||
      product.url;
  }

  /* FIND PRODUCT CARD */

  function getProductCard(btn) {
    return (
      btn.closest('li.product') ||
      btn.closest('.product-item') ||
      btn.closest('.product-card') ||
      btn.closest('.card-product') ||
      btn.closest('[data-product-id]') ||
      btn.parentElement
    );
  }

  /* EXTRACT PRODUCT INFORMATION */

  function extractProduct(btn) {
    var card = getProductCard(btn);

    if (!card) return null;

    var handle =
      btn.getAttribute('data-wishlist-handle') || '';

    var productId =
      btn.getAttribute('data-product-id') || '';

    var title = card.querySelector(
      '.card-title, .card-product__title, .product-title, .product-item__title, [class*="product-title"]'
    );

    var image = card.querySelector(
      '.card-product img, .product-image img, .product-item img, img'
    );

    var price = card.querySelector(
      '.card-price, .price'
    );

    var link = card.querySelector(
      'a[href*="/products/"]'
    );

    var productUrl = link
      ? link.getAttribute('href')
      : (handle ? '/products/' + handle : '');

    var productTitle = title
      ? title.textContent.trim()
      : '';

    if (!productTitle && link) {
      productTitle = link.textContent.trim();
    }

    if (!productTitle && handle) {
      productTitle = handle
        .replace(/-\d+$/, '')
        .replace(/-/g, ' ')
        .replace(/\b\w/g, function (letter) {
          return letter.toUpperCase();
        });
    }

    if (!productTitle || !productUrl) {
      console.warn(
        'Wishlist: Product information missing',
        handle,
        card
      );

      return null;
    }

    return {
      id: productId,
      handle: handle,
      title: productTitle,
      url: productUrl,
      image: image
        ? (image.currentSrc || image.src)
        : '',
      price: price
        ? price.innerText.trim()
        : ''
    };
  }

  /* UPDATE HEADER COUNT */

  function updateCount() {
    var count = getWishlist().length;

    document.querySelectorAll(
      '[data-wishlist-count], .wishlist-count'
    ).forEach(function (badge) {
      badge.textContent = count;
    });
  }

  /* UPDATE HEART BUTTONS */

  function updateHearts() {
    var items = getWishlist();

    document.querySelectorAll(
      '.wishlist-icon[data-wishlist]'
    ).forEach(function (btn) {
      var handle = btn.getAttribute(
        'data-wishlist-handle'
      );

      var productId = btn.getAttribute(
        'data-product-id'
      );

      var exists = items.some(function (item) {
        return (
          (productId && item.id &&
            String(productId) === String(item.id)) ||
          (handle && item.handle === handle)
        );
      });

      btn.classList.toggle('lrn-wished', exists);

      btn.setAttribute(
        'aria-pressed',
        exists ? 'true' : 'false'
      );

      btn.setAttribute(
        'title',
        exists
          ? 'Remove from wishlist'
          : 'Add to wishlist'
      );

      var path = btn.querySelector('path');

      if (path) {
        path.setAttribute(
          'fill',
          exists ? '#8B6B43' : 'none'
        );

        path.setAttribute('stroke', '#1A1410');
      }

      var text = btn.querySelector('.text');

      if (text) {
        text.textContent = exists
          ? 'Remove from wishlist'
          : 'Add to wishlist';
      }
    });
  }

  /* RENDER WISHLIST DRAWER */

  function renderDrawer() {
    var container = document.getElementById(ITEMS_ID);

    if (!container) return;

    var items = getWishlist();

    container.replaceChildren();

    if (!items.length) {
      var empty = document.createElement('div');

      empty.className = 'wishlist-empty';

      empty.textContent =
        'Your wishlist is currently empty.';

      empty.style.cssText =
        'padding:35px 15px;text-align:center;font-family:Jost,sans-serif;font-size:14px;color:#5C4A3A;';

      container.appendChild(empty);

      return;
    }

    items.forEach(function (product) {
      var item = document.createElement('div');

      item.className = 'wishlist-item';

      item.style.cssText =
        'display:flex;gap:15px;padding:15px 0;border-bottom:1px solid #E5DCCE;align-items:center;';

      if (product.image) {
        var imageLink = document.createElement('a');

        imageLink.href = product.url;

        var image = document.createElement('img');

        image.src = product.image;
        image.alt = product.title;
        image.loading = 'lazy';

        image.style.cssText =
          'width:85px;height:105px;object-fit:cover;display:block;';

        imageLink.appendChild(image);

        item.appendChild(imageLink);
      }

      var details = document.createElement('div');

      details.style.cssText =
        'flex:1;min-width:0;';

      var title = document.createElement('a');

      title.href = product.url;
      title.textContent = product.title;

      title.style.cssText =
        'display:block;color:#1A1410;text-decoration:none;font-family:Jost,sans-serif;font-size:14px;margin-bottom:7px;';

      details.appendChild(title);

      if (product.price) {
        var price = document.createElement('div');

        var cleanPrice = String(product.price)
          .replace(/Unit price/gi, '')
          .replace(/\/\s*per/gi, '')
          .replace(/[\r\n]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

        var priceMatch = cleanPrice.match(
          /\d[\d,]*(?:\.\d{2})?/
        );

        price.textContent = priceMatch
          ? priceMatch[0]
          : cleanPrice;

        price.style.cssText =
          'font-family:Jost,sans-serif;font-size:13px;color:#5C4A3A;margin-bottom:10px;';

        details.appendChild(price);
      }

      var remove = document.createElement('button');

      remove.type = 'button';
      remove.textContent = 'Remove';

      remove.setAttribute(
        'data-remove-wishlist',
        getKey(product)
      );

      remove.style.cssText =
        'padding:0;border:0;background:none;color:#8B6B43;font-family:Jost,sans-serif;font-size:11px;text-transform:uppercase;letter-spacing:1px;cursor:pointer;';

      details.appendChild(remove);

      item.appendChild(details);

      container.appendChild(item);
    });
  }

  /* ADD / REMOVE PRODUCT */

  function toggleProduct(product) {
    var items = getWishlist();

    var index = items.findIndex(function (item) {
      return isSameProduct(item, product);
    });

    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push(product);
    }

    saveWishlist(items);
  }

  /* REMOVE FROM DRAWER */

  function removeProduct(key) {
    var items = getWishlist().filter(function (item) {
      return String(getKey(item)) !== String(key);
    });

    saveWishlist(items);
  }

  /* HEART BUTTON CLICK */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '.wishlist-icon[data-wishlist]'
    );

    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var product = extractProduct(btn);

    if (!product) return;

    toggleProduct(product);
  }, true);

  /* DRAWER REMOVE CLICK */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '[data-remove-wishlist]'
    );

    if (!btn) return;

    e.preventDefault();

    removeProduct(
      btn.getAttribute('data-remove-wishlist')
    );
  });

  /* OPEN DRAWER */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-open]');

    if (!btn) return;

    e.preventDefault();

    var drawer = document.getElementById(DRAWER_ID);

    if (!drawer) return;

    renderDrawer();

    drawer.classList.add('open');

    drawer.setAttribute('aria-hidden', 'false');

    document.body.style.overflow = 'hidden';
  });

  /* CLOSE DRAWER */

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-wishlist-close]')) {
      return;
    }

    var drawer = document.getElementById(DRAWER_ID);

    if (!drawer) return;

    drawer.classList.remove('open');

    drawer.setAttribute('aria-hidden', 'true');

    document.body.style.overflow = '';
  });

  /* ESCAPE KEY */

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    var drawer = document.getElementById(DRAWER_ID);

    if (!drawer) return;

    drawer.classList.remove('open');

    drawer.setAttribute('aria-hidden', 'true');

    document.body.style.overflow = '';
  });

  /* CROSS TAB STORAGE SYNC */

  window.addEventListener('storage', function (e) {
    if (e.key !== STORAGE_KEY) return;

    updateCount();
    updateHearts();
    renderDrawer();
  });

  /* INITIALIZE */

  function init() {
    updateCount();
    updateHearts();
    renderDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );

})();
